/* PAPOS 2026 - Header rayos X: apaga el efecto mientras el buscador del header esta abierto
   (su modal es position:fixed dentro del header y el backdrop-filter lo encerraria en la barra). */
(function () {
  var h = document.querySelector('header.header-section');
  if (!h) return;
  function upd() {
    h.classList.toggle('papos-xray-off', !!h.querySelector('details-modal details[open], details-modal[open]'));
  }
  h.addEventListener('toggle', upd, true);
  h.addEventListener('click', function () { setTimeout(upd, 0); }, true);
  document.addEventListener('keyup', function (e) { if (e.key === 'Escape') setTimeout(upd, 0); });
  upd();
})();
